import React from "react";
import "./Common_Back_Btn.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";

const Common_Back_Btn = ({ backText, onClick }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (onClick) {
      onClick(); // run custom function
    } else {
      navigate(-1); // go to previous page
    }
  };

  return (
    <div className="Common_Back_Btn" onClick={handleClick}>
      <FontAwesomeIcon
        icon={faAngleLeft}
        className="back_icon"
      />
      {backText}
    </div>
  );
};

export default Common_Back_Btn;